/* Flora Skin Co. — motion & small enhancements */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var root = document.documentElement;

  /* Split headings into words so they rise in one by one */
  function splitWords(el) {
    if (el.dataset.flSplit) return;
    el.dataset.flSplit = '1';
    var n = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
        if (ch.nodeType === 3) {
          var parts = ch.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var o = document.createElement('span'); o.className = 'fl-w';
            var i = document.createElement('span'); i.textContent = p; i.style.setProperty('--w', n++);
            o.appendChild(i); frag.appendChild(o);
          });
          ch.parentNode.replaceChild(frag, ch);
        } else if (ch.nodeType === 1 && ch.tagName !== 'BR') walk(ch);
      });
    })(el);
    el.classList.remove('fl-rise');
    el.classList.add('fl-split');
  }

  /* Tag elements that should animate in, with a stagger per group */
  function tag() {
    document.querySelectorAll('.fl .fl-h1, .fl .fl-h2').forEach(splitWords);
    var groups = [
      '.fl-strip__item', '.fl-colls > *', '.fl-standard__item', '.fl-rcard', '.fl-faq details, .fl-faq .fl-faq__item',
      '.fl-ritual > a', '.fl-foot__col, .fl-foot__grid > *'
    ];
    groups.forEach(function (sel) {
      var parents = new Map();
      document.querySelectorAll(sel).forEach(function (el) {
        var p = el.parentNode, i = parents.get(p) || 0; parents.set(p, i + 1);
        el.classList.add('fl-rise'); el.style.setProperty('--i', Math.min(i, 8));
      });
    });
    /* Native Horizon sections: product grids, headings */
    document.querySelectorAll('main .shopify-section').forEach(function (s) {
      if (s.querySelector('.fl')) return;
      var items = s.querySelectorAll('.resource-list__item, .product-grid__item, product-card');
      items.forEach(function (el, i) { el.classList.add('fl-rise'); el.style.setProperty('--i', i % 4); });
      s.querySelectorAll('h2').forEach(function (h) { h.classList.add('fl-rise'); });
    });
    document.querySelectorAll('.fl-story__img, .fl-coll, .fl-rcard__prod img').forEach(function (el) { el.classList.add('fl-reveal'); });
  }

  function reveal() {
    if (reduce || design || !('IntersectionObserver' in window)) return;
    tag();
    root.classList.add('fl-motion');
    var els = document.querySelectorAll('.fl-rise, .fl-split, .fl-reveal');
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 9000);
  }

  /* Gentle parallax on large imagery */
  function parallax() {
    if (reduce || design) return;
    var items = Array.prototype.slice.call(document.querySelectorAll('.fl-hero__frame > img, .fl-story__img img'));
    if (!items.length) return;
    var ticking = false;
    function run() {
      var vh = window.innerHeight;
      items.forEach(function (img) {
        var r = img.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.setProperty('--fl-py', (p * -38).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* Header gains a hairline + shadow once you scroll */
  function header() {
    var h = document.querySelector('#header-group, .header-section, header');
    function f() { root.classList.toggle('fl-scrolled', window.scrollY > 40); }
    window.addEventListener('scroll', f, { passive: true }); f();
  }

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var day = d.getDay(); if (day !== 0 && day !== 6) n--; }
    return d;
  }
  function fmt(d) { return d.toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function delivery() {
    document.querySelectorAll('[data-fl-eta]').forEach(function (el) {
      var parts = el.getAttribute('data-fl-eta').split(',').map(Number), now = new Date();
      el.textContent = fmt(addBusinessDays(now, parts[0])) + ' – ' + fmt(addBusinessDays(now, parts[1]));
    });
  }

  function init() { root.classList.add('fl-loaded'); reveal(); parallax(); header(); delivery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
